import { CommonModule } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import {
  FormBuilder,
  FormGroup,
  FormsModule,
  ReactiveFormsModule,
} from '@angular/forms';
import { trigger, state, style, transition, animate, keyframes } from '@angular/animations';

import { CommonServiceService } from '../../shared/services/common-service.service';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-contact-us',
  standalone: true,
  imports: [CommonModule, FormsModule, ReactiveFormsModule],
  templateUrl: './contact-us.component.html',
  styleUrls: ['./contact-us.component.scss'],
  animations: [
    trigger('fadeInOut', [
      transition(':enter', [
        animate('2s ease-out', keyframes([
          style({ transform: 'translateY(-100vh)', offset: 0 }),
          style({ transform: 'translateY(0)', offset: 0.5 }),
          style({ opacity: 1, offset: 1 }),
        ]))
      ]),
      transition(':leave', [
        animate('2s ease-in', style({ opacity: 0 }))
      ])
    ])
  ]
})
export class ContactUsComponent implements OnInit {
  protected contactForm!: FormGroup;
  showAnimation: boolean = true;
  player1Name: string = 'Player 1';
  player2Name: string = 'Player 2';
  constructor(
    private fb: FormBuilder,
    private contactApi: CommonServiceService,
    private toastr: ToastrService
  ) {}

  ngOnInit(): void {
    this.contactForm = this.fb.group({
      username: [''],
      subject: [''],
      feedback: [''],
    });
    setTimeout(() => {
      this.showAnimation = false;
      // Trigger logic to start the next game or navigate away
    }, 4000); // Adjust to 3000ms (3 seconds) or 4000ms (4 seconds) as needed
  }

  contactData(data: any) {
    this.contactApi.contactData(data).subscribe({
      next: (res) => {
        this.toastr.success('Form submitted! We appreciate your feedback.');
      },
    });
  }
}
